import React from "react"
import Box from "@mui/material/Box"

export default function FlashOverlay({ show }: { show: boolean }) {
  if (!show) return null

  return (
    <Box
      sx={{
        bgcolor: "#fff",
        pointerEvents: "none",
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        animation: "flash-fade 900ms ease-in forwards",
        "@keyframes flash-fade": { from: { opacity: 1 }, to: { opacity: 0 } },
      }}
    />
  )
}
